import * as React from 'react';
import {ApplicationState} from "../../store/index";
import {connect} from "react-redux";
import {LogItem} from "./LogItem";

export interface LogBoxProps {
	logs: LogItem[]
}

export interface LogBoxState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		logs: state.core.logs
	};
}

class LogBox extends React.Component<LogBoxProps, LogBoxState> {

	constructor(props: LogBoxProps) {
		super(props)
	}

	componentDidMount() {
		// logger.logBox = this;
	}

	render(): React.ReactNode {

		let logs = this.props.logs
		return (
			<div className='log-box'>{
				logs.reverse().map((log, index) => {
					return (<div key={index}>{log.time} - <span className={'log-' + log.type.toString()}>{log.message}</span></div>)})
			}</div>
		);
	}
}

export default connect(mapStateToProps)(LogBox)
